import { render, staticRenderFns } from "./questionnaireRecord.vue?vue&type=template&id=9c08b448&"
import script from "./questionnaireRecord.vue?vue&type=script&lang=js&"
export * from "./questionnaireRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports